import React from 'react';

import View from './view';
import {useSelector} from 'react-redux';
import {holderProfileSelector, profileSettingsSelector} from '../../../../../redux/selectors/profile';
import {CheckBoxItem} from './checkBoxItem';
import {Type, Notifications, Events} from './checkBoxItem/model';

export const ProfileNotificationSettings = () => {
  const profile = useSelector(holderProfileSelector());
  const profileSettings = useSelector(profileSettingsSelector());

  const notifications = [
    {
      value: (
        <CheckBoxItem
          type={Type.notification}
          notification={Notifications.actionInfo}
          value={!!profileSettings?.receiveInformationShares}
        />
      ),
    },
    {
      value: (
        <CheckBoxItem
          type={Type.notification}
          notification={Notifications.personalOffer}
          value={!!profileSettings?.receiveInformationOffers}
        />
      ),
    },
    {
      value: (
        <CheckBoxItem
          type={Type.notification}
          notification={Notifications.interview}
          value={!!profileSettings?.receiveSurveyInformation}
        />
      ),
    },
  ];

  const obtainingMethod = [
    {
      value: <CheckBoxItem type={Type.event} event={Events.sms} value={!!profileSettings?.events?.isSms} />,
    },
    {
      value: (
        <CheckBoxItem
          type={Type.event}
          event={Events.email}
          value={!!profileSettings?.events?.isEmail}
          disabled={!profile?.email}
        />
      ),
    },
  ];

  return <View notifications={notifications} obtainingMethod={obtainingMethod} />;
};
